import Vue from 'vue';
import {PackingAPI} from "./packing-api";

export class PrintQService {
    constructor() {
        this.configuratorService = {}
        this.observableData = Vue.observable({
            files: [],
        });
        this.packingAPI = {};
        this.TYPE = 'Printq';
    }


    async init(configuratorService) {
        this.configuratorService = configuratorService
        this.packingAPI = new PackingAPI(configuratorService.byConfigoptionType(this.TYPE)?.dynamicValues?.Printqmodel, window.FlyerlineConfig.printQCustomer);

        // url may contain jwt from external editor
        let uri = window.location.search.substring(1);
        let params = new URLSearchParams(uri);
        let jwt = params.get("jwt");
        if( jwt){
            this.configuratorService.byConfigoptionType(this.TYPE).dynamicValues.jwt = jwt;
            this.configuratorService.byConfigoptionType(this.TYPE).dynamicValues.uploadId = "";
            this.configuratorService.validate()
        }
    }

    update3DModel(option, value) {
        this.configuratorService.byConfigoptionType(this.TYPE).dynamicValues.conf3DModel[option] = parseInt(value);

        // change in model/dimensions means design does not fit anymore and needs to be reset
        this.configuratorService.byConfigoptionType(this.TYPE).dynamicValues.customDesignId = ""
        this.configuratorService.byConfigoptionType(this.TYPE).dynamicValues.jwt = ""
        // files are a representation of the design, which has to match the model config.
        // therefore if the model config changes, any files that were valid before cannot be valid anymore
        // and should be removed
        this.deleteFiles()

        this.configuratorService.validate();
    }

    handleDynamicValuesChanged(oldVal, newVal, configuratorService) {
        if (oldVal?.Printqmodel !== newVal?.Printqmodel) {
            this.packingAPI.setModel(newVal?.Printqmodel);
        }
    }

    getPdf() {
        return this.packingAPI.getPdf(this.configuratorService.byConfigoptionType(this.TYPE).dynamicValues.conf3DModel)
    }

    deleteFiles() {
        this.setUploadId("")
        this.observableData.files.splice(0, this.observableData.files.length);
    }

    addfile(file) {
        this.observableData.files.push(file)
    }

    setUploadId(uploadId) {
        this.configuratorService.byConfigoptionType(this.TYPE).dynamicValues.jwt = "";
        this.configuratorService.byConfigoptionType(this.TYPE).dynamicValues.customDesignId = "";
        this.configuratorService.byConfigoptionType(this.TYPE).dynamicValues.uploadId = uploadId;
    }

}